import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconListAdd"><Path d="M18.75 14H22V15.5H18.75V19H17.25V15.5H14V14H17.25V11H18.75V14Z" fill="currentColor"/><Path d="M11 18.75H3V17.25H11V18.75Z" fill="currentColor"/><Path d="M11 12.75H3V11.25H11V12.75Z" fill="currentColor"/><Path d="M21 6.75H3V5.25H21V6.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconListAdd;
